import {
  ISearchResponse,
  pageToSearchInput,
  searchInputToQueryString,
} from '@sales-center/common'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'
import { useQuery } from 'react-query'

const baseUrl = `${ServiceConfig.baseAPIUrl}/contact/search`
export interface IContactSearchEmailModel {
  emailAddress: string
  isPrimary: true
}
export interface IContactSearchModel {
  city: string
  company: string
  emailAddresses: IContactSearchEmailModel[]
  firstName: string
  id: number
  lastName: string
  mobilePhone: string
  phoneExt: string
  phoneNumber: string
  postalCode: string
  stateAbbreviation: string
  street1: string
  street2: string
  title: string
}

const fetchContacts = async (
  query: string | string[],
  page: number,
  perPage: number,
  salesTeamId?: string,
): Promise<ISearchResponse<IContactSearchModel>> => {
  const fallback = { count: 0, items: [], skip: 0, take: 0 }
  if (typeof query === 'string') {
    if (query.trim() == '' || query.trim().length < 3) return fallback
  } else {
    query = query.filter((x) => x.length >= 3)
    if (query.length === 0) return fallback
  }

  const qstring = searchInputToQueryString(
    pageToSearchInput(page, perPage, query, salesTeamId),
  )
  const response = await get(`${baseUrl}?${qstring}`)
  if (response.ok) return await response.json()
  return { count: 0, items: [], skip: 0, take: 0 }
}

export const useContactSearch = (
  query: string | string[],
  page: number,
  perPage: number = 10,
  salesTeamId?: string,
) =>
  useQuery(['contacts', query, page, perPage, salesTeamId], () =>
    fetchContacts(query, page, perPage, salesTeamId),
  )
